<mat-dialog-content>
  <div class="activity">
    <div class="row">
      <div class="col-md-5 d-flex">
        <mat-icon
          *ngIf="!fromCaseView"
          class="mt-2"
          mat-dialog-close
          class="cursor-show"
          (click)="close()"
          >keyboard_arrow_left</mat-icon
        >
        <div class="custom-font-medium font-30 mt-1">
          &nbsp;<span>{{ title }}</span>
        </div>
      </div>
      <div class="col-md-7 text-end" *ngIf="!fromCaseView">
        <mat-icon mat-dialog-close>close</mat-icon>
        <!-- <span>Close</span> -->
      </div>
      <hr />
      <!-- <form [formGroup]="form">
        <div class="row">
          <div class="col-md-10">
            <div class="row topview">
              <div class="col-md-6">
                <div class="w-100">
                  <mat-form-field class="w-100">
                    <mat-label for="sort">Sort By</mat-label>
                    <mat-select
                      placeholder="Select"
                      id="sort"
                      (selectionChange)="SortChange($event)"
                      formControlName="sortBy"
                    >
                      <mat-option
                        *ngFor="let data of Sortbylist"
                        value="{{ data?.optionValue }}"
                      >
                        {{ data?.optionText }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>
              <div class="col-md-6">
                <div class="w-100">
                  <mat-form-field class="w-100">
                    <mat-label for="filter">Filter By</mat-label>
                    <mat-select
                      placeholder="Select"
                      id="filter"
                      (selectionChange)="FilterChange($event)"
                      formControlName="filterBy"
                    >
                      <mat-option
                        *ngFor="let data of Sortbylist"
                        value="{{ data?.optionValue }}"
                      >
                        {{ data?.optionText }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>

              <div class="col-md-6" *ngIf="changesortValue">
                <div class="w-100 mt-20">
                  <mat-radio-group
                    formControlName="order"
                    class="custom-mat-radio-group w-100"
                  >
                    <mat-radio-button value="1">descending</mat-radio-button>
                    <mat-radio-button value="0">ascending</mat-radio-button>
                  </mat-radio-group>
                </div>
              </div>
              <div class="col-md-6" *ngIf="changeValue == '77779347362'">
                <mat-form-field class="w-100">
                  <mat-label>From Date</mat-label>
                  <input
                    matInput
                    formControlName="fromDate"
                    placeholder="DD/MM/YYYY"
                    id="start"
                    [matDatepicker]="picker"
                  />
                  <mat-datepicker-toggle matSuffix [for]="picker">
                  </mat-datepicker-toggle>
                  <mat-datepicker #picker></mat-datepicker>
                </mat-form-field>
              </div>
              <div class="col-md-6" *ngIf="changeValue == '77779347362'">
                <mat-form-field class="w-100">
                  <mat-label>To Date</mat-label>
                  <input
                    matInput
                    formControlName="toDate"
                    placeholder="DD/MM/YYYY"
                    id="to"
                    [matDatepicker]="pickers"
                  />
                  <mat-datepicker-toggle matSuffix [for]="pickers">
                  </mat-datepicker-toggle>
                  <mat-datepicker #pickers></mat-datepicker>
                </mat-form-field>
              </div>
              <div class="col-md-6" *ngIf="changeValue == '77779347361'">
                <mat-form-field class="w-100">
                  <mat-label for="name"> Name</mat-label>
                  <input
                    matInput
                    formControlName="name"
                    type="text"
                    id="name"
                    placeholder="Enter name"
                  />
                </mat-form-field>
              </div>
              <div class="col-md-6" *ngIf="changeValue == '77779347360'">
                <div class="w-100">
                  <mat-form-field class="w-100">
                    <mat-label for="clone">Action Type</mat-label>
                    <mat-select
                      placeholder="Select"
                      id="clone"
                      formControlName="eventType"
                    >
                      <mat-option
                        *ngFor="let data of ActionTypelist"
                        value="{{ data?.optionValue }}"
                      >
                        {{ data?.optionText }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-2" style="text-align: center; margin-top: 2.3rem">
            <button
              type="submit"
              class="form-control btn-custom-primary search-btn"
            >

              Search
            </button>
            <a
              role="button"
              class="text-custom-0019A8 font-20 custom-font-medium"
              (click)="onReset()"
              ><u>Reset Search</u></a
            >
          </div>
        </div>
      </form> -->
      <div class="mt-5">
        <mat-vertical-stepper class="activity-stepper">
          <div *ngFor="let dataitem of auditList; let i = index">
            <mat-step>
              <div class="row">
                <ng-template matStepLabel>
                  <div
                    class="d-flex align-items-center justify-content-between flex-column mb-0 center font-18"
                  >
                    <span
                      class="custom-font-regular font-20 text-break text-wrap width-title text-center"
                      >{{ dataitem.FULLNAME }}</span
                    >
                    <!-- <span class="custom-font-light font-16">
                      {{ dataitem.initOn }}</span
                    > -->
                    <span class="custom-font-light font-16">
                      {{ dataitem.EVENT_DATETIME | date }}</span
                    >
                  </div>
                </ng-template>
                <div class="col-md-12 activity-details mb-activity">
                  <div class="progress-back">
                    <div
                      class="word d-flex justify-content-between"
                      *ngIf="
                        !(
                          dataitem.CHANGED_DATA[0].hasOwnProperty(
                            'sideTableConfig'
                          ) && dataitem.CHANGED_DATA[0].sideTableConfig.status
                        )
                      "
                    >
                      <div class="left_side">
                        <div class="mb-0 custom-font-regular font-20">
                          <span class="dg-txt-primary fw-bold"
                            >Current Component Name -</span
                          >
                          <span> {{ dataitem.CHANGED_DATA[0].fieldName }}</span>
                        </div>

                        <div class="mb-0 custom-font-regular font-20">
                          <span class="dg-txt-primary fw-bold"
                            >Component Type -
                          </span>
                          <span>
                            {{ dataitem.CHANGED_DATA[0].fieldType }}
                          </span>
                          <span
                            class="dg-txt-primary fw-bold"
                            *ngIf="dataitem.CHANGED_DATA[0].fieldId"
                          >
                            |
                          </span>
                          <span
                            class="dg-txt-primary fw-bold"
                            *ngIf="dataitem.CHANGED_DATA[0].fieldId"
                          >
                            Id -
                          </span>
                          <span>{{ dataitem.CHANGED_DATA[0].fieldId }}</span>
                        </div>

                        <!-- <span class="custom-font-light font-16">{{
                          dataitem.description
                        }}</span> -->
                      </div>
                      <div
                        class="right_side d-flex"
                        *ngIf="
                          dataitem.CHANGED_DATA[0].hasOwnProperty('status') &&
                          dataitem.CHANGED_DATA[0].status
                        "
                      >
                        <div
                          class="mt-2"
                          [ngClass]="
                            dataitem.CHANGED_DATA[0].status == 'Added'
                              ? 'green-circle'
                              : 'red-circle'
                          "
                        ></div>
                        <!-- <div class="custom-font-regular font-18">{{chartMethod(dataitem.eventType)}}</div> -->
                        <div class="custom-font-regular font-18">
                          {{ dataitem.CHANGED_DATA[0].status }}
                        </div>
                      </div>
                    </div>
                    <br />
                    <div
                      class="custom-font-light font-16"
                      *ngIf="dataitem.CHANGED_DATA[0]?.dragDetails.status"
                    >
                      <h5 class="dg-fs-14 dg-bg-light p-1">
                        Component dragged
                      </h5>
                      <app-audit-modifier
                        [json]="dataitem.CHANGED_DATA[0].dragDetails"
                      ></app-audit-modifier>
                    </div>
                    <div
                      class="custom-font-light font-16"
                      *ngIf="dataitem.CHANGED_DATA[0]?.fieldJson.status"
                    >
                      <h5 class="dg-fs-14 dg-bg-light p-1">Field Properties</h5>
                      <app-audit-modifier
                        [json]="dataitem.CHANGED_DATA[0].fieldJson"
                      ></app-audit-modifier>
                    </div>
                    <div
                      class="custom-font-light font-16"
                      *ngIf="dataitem.CHANGED_DATA[0]?.ruleJson.status"
                    >
                      <h5 class="dg-fs-14 dg-bg-light p-1">Visibility Rules</h5>
                      <app-audit-modifier
                        [json]="dataitem.CHANGED_DATA[0].ruleJson"
                      ></app-audit-modifier>
                    </div>
                    <div
                      class="custom-font-light font-16"
                      *ngIf="dataitem.CHANGED_DATA[0]?.eventJson.status"
                    >
                      <h5 class="dg-fs-14 dg-bg-light p-1">
                        Event configuration
                      </h5>
                      <app-audit-modifier
                        [json]="dataitem.CHANGED_DATA[0].eventJson"
                      ></app-audit-modifier>
                    </div>
                    <div
                      class="custom-font-light font-16"
                      *ngIf="dataitem.CHANGED_DATA[0]?.tableJson.status"
                    >
                      <h5 class="dg-fs-14 dg-bg-light p-1">
                        Config Table Mapping
                      </h5>
                      <app-audit-modifier
                        [json]="dataitem.CHANGED_DATA[0].tableJson"
                      ></app-audit-modifier>
                    </div>
                    <div
                      class="custom-font-light font-16"
                      *ngIf="dataitem.CHANGED_DATA[0]?.roleJson.status"
                    >
                      <h5 class="dg-fs-14 dg-bg-light p-1">
                        Role configuration
                      </h5>
                      <app-audit-modifier
                        [json]="dataitem.CHANGED_DATA[0].roleJson"
                      ></app-audit-modifier>
                    </div>
                    <div
                      class="custom-font-light font-16"
                      *ngIf="dataitem.CHANGED_DATA[0]?.validateJson.status"
                    >
                      <h5 class="dg-fs-14 dg-bg-light p-1">
                        Validation configuration
                      </h5>
                      <app-audit-modifier
                        [json]="dataitem.CHANGED_DATA[0].validateJson"
                      ></app-audit-modifier>
                    </div>
                    <div
                      class="custom-font-light font-16"
                      *ngIf="
                        dataitem.CHANGED_DATA[0].hasOwnProperty(
                          'sideTableConfig'
                        ) && dataitem.CHANGED_DATA[0]?.sideTableConfig.status
                      "
                    >
                      <span class="custom-font-regular font-20"
                        >Table configuration</span
                      >
                      <app-audit-modifier
                        [json]="dataitem.CHANGED_DATA[0].sideTableConfig"
                      ></app-audit-modifier>
                    </div>
                  </div>
                </div>
              </div>
            </mat-step>
          </div>
        </mat-vertical-stepper>
      </div>
    </div>
  </div>
</mat-dialog-content>
